'use client';

import { useEffect } from 'react';

export default function TimezoneCookie() {
  useEffect(() => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (!timezone) return;
    const year = 365 * 24 * 60 * 60 * 1000;
    document.cookie = `timezone=${encodeURIComponent(timezone)}; path=/; samesite=lax; max-age=${year / 1000}`;
  }, []);
  return null;
}
